import { Document } from '../../interfaces/Document';
import { DocumentDto } from '../../interfaces/Dto/DocumentDto';
import { DocumentGroupingDto } from '../../interfaces/Dto/DocumentGroupingDto';

export default function transformDocuments(dtos: DocumentDto[], documentGroupings: DocumentGroupingDto[]): Document[] {
  const documents: Document[] = [];
  dtos?.forEach((dto) => {
    documents.push({
      id: dto.id,
      name: dto.name,
      date: new Date(dto.publishDate),
      year: dto.year,
      type: {
        id: dto.documentType?.id.toString(),
        name: dto.documentType?.name,
      },
      contract: {
        contractNumber: dto.contract?.number,
        contractName: dto.contract?.name,
        systemCode: dto.contract?.systemCode,
      },
      visible: true,
      read: dto.isRead,
      grouped: dtos.length > 1 && documentGroupings.some((x) => x.systemCode === dto.contract?.systemCode && x.documentTypeId === dto.documentType?.id),
      fileToken: dto.fileToken,
    });
  });
  return documents;
}
